import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ApiService from "@/api/ApiService";
import { number } from '@amcharts/amcharts4/core';
Vue.use(VueAxios, axios)
export const EvohealthService = {
  baseURL: process.env.VUE_APP_EVOHEALTH_URL,

  getHealthParamsByGroup(healthGroupId) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}v1/health-group/${healthGroupId}/health-params`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  }

}


